export const mapBooleanToEnabledDisabled = (value: boolean) => (value ? "enabled" : "disabled");
